import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cluster",
  "use": "cluster-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"cluster\"><path d=\"M11 3.494 4.5 7.247v7.506l6.5 3.753 6.5-3.753V7.247zm0 1.732 4.227 2.44-1.99 1.161L11 7.537 8.736 8.842l-2.01-1.148zm-.75 11.115L6 13.887v-4.88l2 1.143v2.582l2.25 1.3zm-.75-4.475v-1.732l1.5-.866 1.5.866v1.731l-1.5.866zm6.5 2.021-4.227 2.44-.01-2.304-.013.008L14 12.732V10.12l2-1.167z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol